import { z } from 'zod';

export const nonEmptyString = z.string().trim().min(1, 'Required');

export const slug = z
  .string()
  .trim()
  .min(1, 'Required')
  .max(80, 'Max 80 characters')
  .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/, 'Lowercase letters, digits and dashes only');

export const cuidLike = z
  .string()
  .min(20, 'Invalid id')
  .max(40, 'Invalid id')
  .regex(/^[a-z0-9]+$/, 'Invalid id');

export const positiveDecimal = z.number().nonnegative('Must be ≥ 0');

export const isoLanguageCode = z
  .string()
  .length(2, 'ISO 639-1 (2 letters)')
  .regex(/^[a-z]{2}$/, 'Lowercase ISO 639-1 code');

export const paginationInput = z.object({
  cursor: z.string().optional(),
  limit: z.number().int().min(1).max(100).default(20),
});

export type PaginationInput = z.infer<typeof paginationInput>;
